<div class="card">
    <div class="card-body">
        <h4 class="card-title">Usuarios registrados</h4>
        <h6 class="card-subtitle">Ver y editar usuarios</h6>
        <div class="col-12">
            <div class="demo-checkbox row">
                <input type="checkbox" [(ngModel)]="inactives" id="basic_checkbox_1" >
                <label for="basic_checkbox_1" class="mb-0 mb-md-2" >Mostrar inactivos</label>
                <input type="checkbox" [(ngModel)]="firstBuy" id="basic_checkbox_2" >
                <label for="basic_checkbox_2" class="mb-0 mb-md-2" >Usuarios sin compras realizadas</label>
            </div>

        </div>
        <div class="row my-3">
            <div class="col-12">
                <input type="text" class="form-control" placeholder="Buscar por nombre, email o plan" [(ngModel)]="filter" />
            </div>
        </div>
        <div *ngIf="users" class="table-responsive">
            <table class="table table-bordered table-hover toggle-circle " >
                <thead>
                    <tr>
                        <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Nombre y apellido<span class="footable-sort-indicator"></span></th>
                        <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Empresa<span class="footable-sort-indicator"></span></th>
                        <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Suscripción<span class="footable-sort-indicator"></span></th>
                        <th class="footable-visible footable-sortable">Email<span class="footable-sort-indicator"></span></th>
                        <th class="footable-visible footable-sortable">Pagos<span class="footable-sort-indicator"></span></th>
                        <th class="footable-visible footable-sortable">Último plan<span class="footable-sort-indicator"></span></th>
                        <th data-hide="phone, tablet" class="footable-visible footable-sortable">Fecha de registro<span class="footable-sort-indicator"></span></th>
                        <th data-hide="phone, tablet" class="footable-visible footable-sortable">Fecha de finalización de plan<span class="footable-sort-indicator"></span></th>
                        <th data-hide="phone, tablet" class="footable-visible footable-sortable">Pruebas disponibles<span class="footable-sort-indicator"></span></th>
                        <th data-hide="phone, tablet" class="footable-visible footable-sortable">Rol<span class="footable-sort-indicator"></span></th>
                        <th data-hide="phone, tablet" class="footable-visible footable-sortable">Estado<span class="footable-sort-indicator"></span></th>
                        <th class="min-width footable-visible footable-last-column text-center">Acciones</th>
                       
                    </tr>
                </thead>
                
                <tbody>
                    <tr *ngFor="let user of users| users:inactives:evaluated:!firstBuy | searchUser: filter">
                        <td class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{user.name}} {{user.surname}}</td>
                        <td class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{user.company}}</td>
                        <td *ngIf="!user.canUseCustomTests" class="footable-visible footable-first-column"><span class="footable-toggle"></span> - </td>
                        <td *ngIf="user.canUseCustomTests" class="footable-visible footable-first-column"><span class="footable-toggle"></span> {{user.canUseCustomCreator ? 'Ev+Cr' : 'Ev'}} - {{user.subscriptionType == 'monthly' ? 'Me' : 'An'}} </td>
                        <td class="footable-visible">{{user.email}}</td>
                        <td class="footable-visible">{{user.payments.length}}</td>
                        <td class="footable-visible">{{user.payments.length == 0 ? '-' : user.payments[user.payments.length - 1].description | paymentType}}</td>
                        <td class="footable-visible">{{user.registerDate| date:'mediumDate'}}</td>
                        <td class="footable-visible">{{user.payments.length == 0 ? '-' : setYearDate(user.lastPurchase) | date:'mediumDate'}}</td>
                        <td class="footable-visible">{{user.remainingTests}}</td>
                        <td *ngIf="user.role==='admin'" class="footable-visible"><span class="label label-table label-danger">{{user.role}}</span> </td>
                        <td *ngIf="user.role==='client'" class="footable-visible"><span class="label label-table label-success">{{user.role}}</span> </td>
                        <td *ngIf="user.role==='evaluated'" class="footable-visible"><span class="label label-table label-info">{{user.role}}</span> </td>
                        <td *ngIf="!user.active" class="footable-visible"><span class="label label-table label-danger selectable-hand" (click)="changeState(user)">Inactivo</span> </td>
                        <td *ngIf="user.active" class="footable-visible"><span class="label label-table label-success selectable-hand" (click)="changeState(user)">Activo</span> </td>
                        <td class="footable-visible footable-last-column text-center">
                            <button title="Ver/Editar" type="button" class="btn btn-sm btn-icon btn-pure btn-outline delete-row-btn" (click)="handleEdit(user.email)" ><i class="fa fa-eye" aria-hidden="true"></i></button>
                            <button title="Evaluaciones" type="button" class="btn btn-sm btn-icon btn-pure btn-outline delete-row-btn" (click)="viewEvaluations(user)" ><i class="fa fa-users" aria-hidden="true"></i></button>
                        </td>
                    </tr>
                </tbody>
         
            </table>

        </div>
    </div>
</div>


<div *ngIf="tests.length>0" class="card">

    <div class="card-body">
        <h4 class="card-title"> Cliente seleccionado: {{selectedName}}
            <button *ngIf="!inTrash" class="btn btn-info waves-effect btn-sm pull-right" (click)="showTrash()">Ver papelera</button>
            <button *ngIf="inTrash" class="btn btn-info waves-effect btn-sm pull-right" (click)="back()">Volver</button>
        
        </h4>
        <table class="table table-bordered table-hover " >
            <thead>
                <tr>
                    <th >Nombre y apellido</th>
                    <th >Email del evaluado</th>
                    <th >Test</th>
                    <th >Fecha de creación</th>
                    <th >Estado</th>
                    <th >Acción</th>
                </tr>
            </thead>
            
            <tbody>
                <tr *ngFor="let test of tests; index as i">
                    <td class="footable-visible">{{test.evaluatedName}}</td>
                    <td class="footable-visible">{{test.isLocal ? 'Evaluado localmente' : test.evaluated}}</td>
                    <td >{{test.type}}</td>
                    <td class="footable-visible">{{test.createDate | date:'mediumDate'}}</td>
                    <td *ngIf="test.isCompleted" class="footable-visible"><span class="label label-success laber-rounded">Realizado</span></td>
                    <td *ngIf="!test.isCompleted&&!test.isStarted" class="footable-visible"><span class="label label-danger laber-rounded">Pendiente</span></td>
                    <td *ngIf="!test.isCompleted&&test.isStarted" class="footable-visible">
                        <span class="label label-warning laber-rounded">Usuario bloqueado</span>
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline" title="Desbloquear" (click)="reloadTest(test)" ><i class="fa fa-recycle" ></i></button>
                    </td>
                    <td class="footable-visible footable-last-column text-center">
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " title="Editar" data-toggle="modal" data-target=".editModal" (click)="handleEdit(test.evaluated)" ><i class="fa fa-pencil" ></i></button>                        <button *ngIf="!test.trash" type="button" class="btn btn-sm btn-icon btn-pure btn-outline " title="Enviar a la papelera" (click)="trash(test)" ><i class="fa fa-trash-o"></i></button>
                        <button *ngIf="test.trash" type="button" class="btn btn-sm btn-icon btn-pure btn-outline " title="Restaurar" (click)="trash(test)" ><i class="fa fa-backward"></i></button>
                    </td>
                </tr>
            </tbody>
            
        </table>
    </div>
</div>